export default {
  subjectGroup: {
    id: '',
    faculty: '',
    code: '',
    nameLocal: '',
    nameEng: '',
  },
  subjectGroups: [],
  processing: false,
  error: null,
  success: null,
}



